import { useQuery } from '@tanstack/react-query'

import { getSsoJwt } from '@src/api'
import { DefaultApiGetJwtSsoRequest } from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchSsoJwt = (params: DefaultApiGetJwtSsoRequest) => {
  const { axiosInstance } = useAxios()

  return useQuery({
    enabled: !!params.nonce,
    queryFn: () => getSsoJwt(axiosInstance, params),
    queryKey: [REACT_QUERY_CACHE_KEYS.GET_SSO_JWT, params.nonce],
  })
}
